import {app, db} from "../firebase";
import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    getDoc,
    getDocs,
    orderBy,
    query,
    setDoc,
    where
} from 'firebase/firestore'


import {getFunctions, httpsCallable} from "firebase/functions";
import {returnAuthBool} from "../components/CONSTANTS";

const functions = getFunctions(app, 'europe-west3');


const addCompanyAsAdmin = httpsCallable(functions, 'createCompanyAsAdmin');
const addLeadAsAdmin = httpsCallable(functions, "addLeadAsAdmin");

const addUserAsAdmin = httpsCallable(functions, "addUserAsAdmin");
const companyCollectionRef = collection(db, 'Company');
const usersCollectionRef = collection(db, 'User');
const messageCollectionRef = collection(db, "Messages")
const leadsCollectionRef = collection(db, 'Formsdata');
const AdminLogCollectionRef = collection(db, "AdminLog");
const adminAppCollectionRef = collection(db, "App");
const removeLeadCloud = httpsCallable(functions, "removeLeadCloud");

export const addUserAsAdminInCloud = async (firstNameRef, lastNameRef, emailRef, companyRef, authRef, passwordRef, superadminRef,) => {

    let authTemp = returnAuthBool(authRef);
    let superadminTemp = returnAuthBool(superadminRef);


    const data = {
        firstName: firstNameRef,
        lastName: lastNameRef,
        email: emailRef,
        company: companyRef,
        authRef: authTemp,
        password: passwordRef,
        superadmin: superadminTemp,
    }


    return await addUserAsAdmin(data);


}

export const updateUserAsAdmin = async (id, allowWebRef) => {
    let docRef = doc(db, "User", id);
    let allowWebRefBool = returnAuthBool(allowWebRef);

    await setDoc(docRef, {
        allowWeb: allowWebRefBool
    }, {merge: true})


}

export const AdminAddService = async (company, service, qr) => {
    const docRef = collection(db, "ServiceCompany");
    await addDoc(docRef, {
        QR: qr,
        company: company,
        service: service
    });
}

export const UpdateServiceAsAdmin = async () => {

}

export const updateCompanyReference = async (ref, match) => {
    const docRef = doc(db, "Company", match);

    let refLowerCase = ref.toLowerCase();

    await setDoc(docRef, {
        referensadmin: refLowerCase
    }, {merge: true});

}

export const updateAmountOfAccounts = async (amount, match) => {
    const docRef = doc(db, "Company", match);

    let insertValue = parseInt(amount);
    await setDoc(docRef, {
        amountofAccounts: insertValue
    }, {merge: true})
}

export const getCompany = async (match) => {

    let object = {}

    const docRef = doc(db, 'Company', match);

    await getDoc(docRef).then(function (snapshot) {
        object = snapshot.data();
    });

    return object;

}

export const removeLead = async (id) => {
    const leadDoc = doc(db, "FormsData", id);
    await deleteDoc(leadDoc).then(() => {
    }).catch(() => console.error);
}
export const removeUser = async (id) => {

    try {
        await deleteDoc(doc(db, "User", id))
    } catch (e) {
    }

}

export const getAppData = async () => {

    const docRef = doc(db, "App", "eB7YA8p1jcd0EBXnKr4l");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        return "no doc found";
    }
}



export const getAllCompanies = async () => {
    const querySnapshot = await getDocs(companyCollectionRef);
    return (querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id})));
}

export const getAllUsers = async () => {
    const querySnapshot = await getDocs(usersCollectionRef);
    return (querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id})))
}

export const getAllUsersFromCompany = async (company) => {
    const q = await query(usersCollectionRef, where("company", "==", company));
    return (await getDocs(q)).docs.map((doc) => ({...doc.data(), id: doc.id}));
}

export const getAllLeads = async () => {
    const querySnapshot = await getDocs(leadsCollectionRef);
    return (querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id})))
}

export const addCompany = async (company, amountofAccounts) => {

    const data = {
        companyName: company,
        amountofAccounts: amountofAccounts
    }

    await addCompanyAsAdmin(data);
}

export const getLatestLeads = async () => {
    const querySnapshot = await getDocs(leadsCollectionRef, orderBy("formInsertedAt"));
    return (querySnapshot.docs.map((doc) => ({...doc.data(), id: doc.id})));
}


export const addLeadAsAdminClient = async (companyRef,
                                           approvedRef,
                                           dealstageRef,
                                           emailRef,
                                           firstNameRef,
                                           lastNameRef,
                                           leadgeneratorRef) => {

    const emailLowerCase = emailRef.toLowerCase();

    const data = {
        email: emailLowerCase,
        firstname: firstNameRef,
        lastname: lastNameRef,
        company: companyRef,
        dealstage: dealstageRef,
        reference: leadgeneratorRef,

    }
    await addLeadAsAdmin(data);
}

export const getAdminLogs = async () => {
    const q = await getDocs(AdminLogCollectionRef);
    return (q.docs.map((doc) => ({...doc.data(), id: doc.id})));
}

export const getAdminMessages = async () => {
    const q = await getDocs(messageCollectionRef);
    return (q.docs.map((doc) => ({...doc.data(), id: doc.id})));
}


